import React, { useState } from "react";
import { rem } from "polished";
import styled, { css } from "styled-components";

import mq from "../../../helpers/media-queries";
import ArrowDown from "../../../assets/img/arrowdown.png";
import ArrowUp from "../../../assets/img/arrow-up.png";

const SideControls = styled.div`
	position: absolute;
	left: ${rem(50)};
	top: 50%;
	transform: translateY(-50%);
	background-color: transparent;
	${mq("sm", "max")} {
		display: none;
	}
`;

const Wrap = styled.ul`
	background-color: transparent;
	max-height: ${rem(340)};
	overflow: hidden;

	${(props) =>
		css`
			* {
				transition: transform 0.3s ease-out;
				transform: translateY(${-35 * props.position}px);
			}
		`}
`;

const Control = styled.li`
	width: ${rem(50)};
	height: ${rem(50)};

	button {
		width: 100%;
		height: 100%;
		appearance: none;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center center;
		border-radius: 999em;
		border: 0;
		cursor: pointer;

		&:focus {
			outline: none;
		}
	}

	&:not(:last-of-type) {
		margin-bottom: ${rem(20)};
	}
`;

const Up = styled.div`
	width: ${rem(50)};
	height: ${rem(50)};
	border: 1px solid #a4998f;
	border-radius: 50%;
	background-color: #fff;
	justify-content: center;
	align-items: center;
	margin-bottom: ${rem(12)};
	display: none;
	cursor: pointer;

	${(props) =>
		props.show &&
		css`
			display: flex;
		`}

	img {
		width: ${rem(26)};
	}
`;
const Down = styled.div`
	width: ${rem(50)};
	height: ${rem(50)};
	border: 1px solid #a4998f;
	border-radius: 50%;
	background-color: #fff;
	justify-content: center;
	align-items: center;
	margin-top: ${rem(12)};
	display: none;
	cursor: pointer;

	${(props) =>
		props.show &&
		css`
			display: flex;
		`}

	img {
		width: ${rem(26)};
		object-fit: contain;
	}
`;

const Gallery = ({ data, isOpen, setIsOpen, setOpenSlide, color }) => {
	const [position, setPosition] = useState(0);

	function showImage(item) {
		let img;
		if (color === 1 && item.secondImage) {
			img = item.secondImage;
		} else {
			img = item.image;
		}
		return img;
	}

	return (
		<React.Fragment>
			<SideControls>
				<Up
					show={data.details.items.length > 5}
					onClick={() => {
						if (position === 0) {
							return;
						} else {
							setPosition(position - 1);
						}
					}}
				>
					<img src={ArrowUp} alt="" />
				</Up>
				<Wrap position={position}>
					{data.details.items.map((item, index) => {
						return (
							<Control key={index}>
								<button
									style={{ backgroundImage: `url(${showImage(item)})` }}
									onClick={() => {
										setIsOpen(true);
										setOpenSlide(index);
									}}
								></button>
							</Control>
						);
					})}
				</Wrap>
				<Down
					show={data.details.items.length > 5}
					onClick={() => {
						if (position === data.details.items.length - 5) {
							return;
						} else {
							setPosition(position + 1);
						}
					}}
				>
					<img src={ArrowDown} />
				</Down>
			</SideControls>
		</React.Fragment>
	);
};

export default Gallery;
